import { Navigate } from 'react-router-dom'

import { useAppSelector } from 'src/store/hooks'
import { selectUseQuizAnalyticsV2 } from 'src/v3/settings/settings.slice'
import QuizAnalyticsTabbedPage from './components/quiz-analytics-tabbed-page'
import QuizAnalyticsEmptyState from './components/quiz-analytics-empty-state'

let QuizAnalyticsLearnersContent = () => (
  <QuizAnalyticsTabbedPage>
    <QuizAnalyticsEmptyState
      title="Learner analytics are coming soon"
      description="Quiz performance for each learner in your organization will appear here."
    />
  </QuizAnalyticsTabbedPage>
)

let QuizAnalyticsLearnersPage = () => {
  let useQuizAnalyticsV2 = useAppSelector(selectUseQuizAnalyticsV2)

  if (!useQuizAnalyticsV2) {
    return <Navigate to="/manage" replace />
  }

  return <QuizAnalyticsLearnersContent />
}

export default QuizAnalyticsLearnersPage
